import React from "react"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

const BreadCrumb = (props) => {
   const [items, setItems] = useState([])
   
   // Get navigate and location from props (passed from HeaderComponent)
   const navigate = props.navigate
   const location = props.location
   
   // In React Router v6, there's no history.action, use location state instead
   const action = location?.state?.action || "PUSH"
   const pathName = location?.pathname || ""

   useEffect(() => {
      function setBreadCrumb(pathName) {
         var newArray = []
         var searchItemsNew = {}
         var arrItems = []

         if (
            sessionStorage.getItem("breadCrumb") != null &&
            sessionStorage.getItem("breadCrumb") !== ""
         ) {
            try {
               arrItems = JSON.parse(atob(sessionStorage.getItem("breadCrumb")))
            } catch (e) {
               // Stored value is not valid base64 JSON (stale or malformed data); reset it
               sessionStorage.removeItem("breadCrumb")
               addValueToSessionStorage()
               return
            }
            var index = arrItems.findIndex((e) => e.link === pathName)
            if (index < 0 && action === "POP") {
               sessionStorage.removeItem("breadCrumb")
               addValueToSessionStorage()
            } else if (index < 0 && !pathName.includes("search")) {
               addValueToSessionStorage()
            } else {
               newArray = arrItems.slice()
               //delete element by index
               newArray.splice(index + 1)

               resetSessionStorage()
            }
         } else {
            addValueToSessionStorage()
         }

         function resetSessionStorage() {
            sessionStorage.removeItem("breadCrumb")
            sessionStorage.setItem("breadCrumb", btoa(JSON.stringify(newArray)))
            setItems(JSON.parse(atob(sessionStorage.getItem("breadCrumb"))))
         }

         function addValueToSessionStorage() {
            if (props.name) {
               searchItemsNew["name"] = props.name
               searchItemsNew["link"] = pathName
               arrItems.push(searchItemsNew)
               newArray = arrItems.slice()
               resetSessionStorage()
            }
         }
      }
      setBreadCrumb(pathName)

      return () => {
         return undefined
      }
   }, [pathName, props.name, action])

   const deleteItems = (e, name) => {
      //find index of element
      var index = items.findIndex((e) => e.name === name)
      //copy array
      var newArray = items.slice()
      //delete element by index
      newArray.splice(index + 1)
      sessionStorage.removeItem("breadCrumb")
      sessionStorage.setItem("breadCrumb", btoa(JSON.stringify(newArray)))
   }

   return (
      <div className="accordIconStyle">
         {items && items.length > 0 && (
            <ul className="breadcrumb">
               {items.map((item, index) => (
                  <li key={index}>
                     <Link
                        to={item.link}
                        onClick={(e) => deleteItems(e, item.name)}
                     >
                        {item.name}
                     </Link>
                  </li>
               ))}
            </ul>
         )}
      </div>
   )
}

export default BreadCrumb